import Client from '../Client';
import AccountingStat from "../../models/AccountingStat";
import RestClient from "./RestClient";
import _ from 'lodash';

class AccountingStats extends RestClient {
    constructor() {
        super({
            "model": AccountingStat,
            "entryPoint": "accountings",
            "resource": "accounting",
            "resources": "accountings",
            "id_field": "_id"
        });

        this.client = new Client();
    }

    /**
     * Get sales statistics
     * @param {Object} params - Query parameters
     * @returns {Promise} - API response
     */
    getStats(params) {
        // remove empty filter values
        params = _.pickBy(params, _.identity);

        return this.client.GET('/accountings/stats', params)
            .then(response => response.json())
            .catch(error => {
                console.error('Error fetching accounting stats:', error);
                throw error;
            });
    }
}

const AccountingStatsApi = new AccountingStats();

export default AccountingStatsApi;
